export const version = "signing-key/5.0.8";
//# sourceMappingURL=_version.js.map